import { render } from "./GapBasesList.vue?vue&type=template&id=8ccd521a&scoped=true"
import script from "./GapBasesList.vue?vue&type=script&lang=js"
export * from "./GapBasesList.vue?vue&type=script&lang=js"

import "./GapBasesList.vue?vue&type=style&index=0&id=8ccd521a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.32_vue@3.5.32_typescript@5.9.3__webpack@5.106.2_@swc+core@1.3.96_/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ccd521a"]])

export default __exports__